import React from "react";

const CheckCircleIcon = () => {
  return (
    <div className="text-primary">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="178"
        height="178"
        viewBox="0 0 178 178"
        fill="none"
        className="stroke-current"
      >
        <g filter="url(#filter0_d_11599_3614)">
          <path
            d="M66.75 94.5625L83.4375 111.25L111.25 72.3125M155.75 89C155.75 125.865 125.865 155.75 89 155.75C52.135 155.75 22.25 125.865 22.25 89C22.25 52.135 52.135 22.25 89 22.25C125.865 22.25 155.75 52.135 155.75 89Z"
            stroke="currentColor"
            stroke-width="4.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_11599_3614"
            x="10"
            y="10"
            width="158"
            height="158"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11599_3614"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11599_3614"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default CheckCircleIcon;
